<template>
  <div id="planandprepare" class="planandprepare">
    <header-img :imgs="imgs"></header-img>
    <!-- 筹划定义 -->
    <div class="p-prepare">
      <h1 class="prepare-h1">税收合规安排定义</h1>
      <div class="prepare-items">
        <div class="item-img">
          <img src="./images/seet.png" alt />
        </div>
        <div class="item">
          <p>&emsp;&emsp;我们中税税务师事务所拥有专业的注册会计师/税务师团队，从业经验丰富，精通税法政策，可根据不同企业的具体情况，通过对企业经营、投资、理财等活动的筹划和安排，针对企业问题提供专业的解决方案和合理规划，尽可能帮助企业减轻税收负担，在法律允许和不违反税法的前提下，最大限度地维护纳税人的利益。</p>
        </div>
      </div>
    </div>
    <!-- 解决方案 -->
    <div class="quality">
      <h1 class="quality-h1">税收合规安排专业解决方案</h1>
      <p class="quality-p1">掌握策划原理，提供专业方案</p>
      <div class="quality-items">
        <div class="item">
          <div class="item-img">
            <img src="./images/组 2938.png" alt />
          </div>
          <!-- <p>增值税节税筹划方案</p> -->
        </div>
        <div class="item">
          <div class="item-img">
            <img src="./images/组 2939.png" alt />
          </div>
          <!-- <p>企业所得税节税筹划方案</p> -->
        </div>
        <div class="item">
          <div class="item-img">
            <img src="./images/组 2940.png" alt />
          </div>
          <!-- <p>工资薪金节税筹划方案</p> -->
        </div>
        <div class="item">
          <div class="item-img">
            <img src="./images/组 2937.png" alt />
          </div>
          <!-- <p>股权转让个人所得税筹划方案</p> -->
        </div>
        <div class="item">
          <div class="item-img">
            <img src="./images/组 2936.png" alt />
          </div>
          <!-- <p>利润分红个人所得税筹划方案</p> -->
        </div>
        <div class="item">
          <div class="item-img">
            <img src="./images/组 2935.png" alt />
          </div>
          <!-- <p>资产重组税收合规安排方案</p> -->
        </div>
      </div>
    </div>
    <!-- 多种行业的税收合规安排方案 -->
    <div class="multiple">
      <div class="multiple-textn">
        <h1>多种行业的税收合规安排方案</h1>
        <p>根据企业不同行业，量身定制筹划方案，最大限度降低税负</p>
      </div>
      <div class="multiple-items">
        <div class="item" v-for="item of multiple" :key="item.img">
          <div class="item-img">
            <img :src="item.img" alt />
          </div>
          <div class="item-text">
            <p>{{item.title}}</p>
            <a href="/">{{item.tell}}</a>
          </div>
        </div>
      </div>
    </div>
    <!-- 经典案例回顾 -->
    <div class="cancelled-case">
      <h1 class="cancelled-case-h2">中税经典税收合规安排案例回顾</h1>
      <div class="case-frame">
        <div class="frame-item">
          <div class="item-img">
            <img src="./images/VCG41N1020863554.png" alt="">
          </div>
          <div class="item-text">
            <h3>企业所得税筹划案例</h3>
            <p>&emsp;某客户公司经营良好，利润丰厚，但老板缺钱时经常从公司账户提款至个人账户，往来款长期挂账，而且未能及时关注税收政策变化带来的优惠，公司利润虚高，白白多交税；同时，还因为利润虚高外购发票冲账，经不起税务稽查，积累大量风险。</p>
            <p>&emsp;中税结合客户行业特点，用足用好各类税收优惠，并协助客户调整商业模式，基于真实业务的基础之上进行业务流程再造，合理合法降低企业所得税税负，并且规避税务风险。</p>
          </div>
        </div>
      </div>
      <div class="case-frame">
        <div class="frame-item">
          <div class="item-img">
            <img src="./images/6ef223e801f419e8c3a9e6eb2a135ff47a10115958ac4-ncynlE_fw658.png" alt="">
          </div>
          
          <div class="item-text">
            <h3>1、综合所得个人所得税筹划</h3>
            <p>&emsp;某客户公司系国家高新企业，管理层及研发人员薪资高，个人所得税税负重，而且员工纳税意识不强，个税问题难解决。</p>
            <p>&emsp;中税针对客户公司行业特点，审计调研公司真实情况，为客户提供多方位综合性节税方案，包括调整工资发放模式、合理划分发放金额、进行收入类型转换、设立员工股票期权等，同时采用在政策优惠园区设立个人独资企业、核定征收等方式，成功节约个人所得税。</p>
            <p>&emsp;方案适用人群：企业主、自由职业者、网红、演艺明星、讲师、设计师、律师、私募管理人等高净值人群。</p>
            <h3>2、股权转让个人所得税筹划</h3>
            <p>&emsp;某客户公司由于内部股权架构调整的需要，将股权进行转让，由于公司经营良好，账面留有大量利润，而且有房产、无形资产、长期投资等增值资产，导致股权转让过程涉及大量个人所得税。中税针对客户实际情况，精选适用之相关政策，部门分工合作，承办整个股转流程，成功节税并顺利完成股权转让。</p>
          </div>
        </div>
      </div>
      <div class="case-frame">
        <div class="frame-item">
          <div class="item-img">
            <img src="./images/30ebddfa5e6353023687b24d663a51f3ce801d0c591ad-pCI085_fw658.png" alt="">
          </div>
          <div class="item-text">
            <h3>企业整体税收合规安排案例</h3>
            <p>&emsp;某集团公司客户为公司整体发展考虑，吸收合并子公司（有房产及土地），该过程中涉及增值税、城建税、土地增值税、企业所得税、印花税、契税等各类税种，金额大，税负重。</p>
            <p>&emsp;我公司建议集团公司利用税法规定的特殊性重组政策，对子公司进行吸收合并，协助客户制订整体重组方案，协助与主管税务机关及工商部门沟通整体流程及方案的落地，成功完成吸收合并工作，整个流程几乎实现了零税负，客户十分满意。</p>
          </div>
        </div>
      </div>
      <div class="case-frame">
        <div class="frame-item">
          <div class="item-img">
            <img src="./images/854f97c673f149c3b4aebc8bfefcc8da31943e1d49710-VyCb1d_fw658 (1).png" alt="">
          </div>
          <div class="item-text">
            <h3>成功应对税务稽查案例</h3>
            <p>&emsp;某客户公司，被同行举报，税务稽查介入。但实际上，客户公司出现的一些税务上的“违规”项目，有其内在原因，也是生产经营的需要，可以进行申诉。中税接受客户委托后，审计调研公司实际情况，精选适用之税收政策，灵活运用，进行策略性安排，并协助客户跟稽查人员认真沟通，最后成功降低补税金额以及罚款系数。</p>
          </div>
        </div>
      </div>
      <div class="case-frame">
        <div class="frame-item">
          <div class="item-img">
            <img src="./images/3dfed8701f47df8946af427bed7ad63aa883d0ed191b0-Y1QQMY_fw658.png" alt="">
          </div>
          <div class="item-text">
            <h3>增值税税收合规安排案例</h3>
            <p>&emsp;某客户系生产贸易公司，产品技术壁垒高，细分市场占有率高，毛利率高，导致增值税税负也相当高。中税与全国多个政策优惠的招商园区均有对接合作，协助客户选择适合其产业的靠谱园区，协助项目落地，采取设立集中采购基地等商业模式，在业务真实的基础上进行流程再造。落地企业可享受增值税地方留存部分的50%—70%，企业总增值税纳税额的25%—35%，例：企业缴纳100万的增值税，即可享受到25万—35万的奖励，实现合理合法的节税。</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderImg from "@/common/herder-img";
import imgs from "./images/组 2931.png";

export default {
  name: "planandprepare",
  data() {
    return {
      imgs: imgs,
      multiple: [
        {
          img: require("./images/组 2941.png"),
          title: "投资/基金/金融公司（合伙企业）",
          tell: "立即咨询>"
        },
        {
          img: require("./images/组 2942.png"),
          title: "咨询/服务/研发行业",
          tell: "立即咨询>"
        },
        {
          img: require("./images/组 2943.png"),
          title: "生产加工行业",
          tell: "立即咨询>"
        },
        {
          img: require("./images/组 2944.png"),
          title: "影视娱乐文化广告行业",
          tell: "立即咨询>"
        },
        {
          img: require("./images/组 2945.png"),
          title: "贸易流通行业",
          tell: "立即咨询>"
        },
        {
          img: require("./images/组 2946.png"),
          title: "讲师/设计师/律师/行业",
          tell: "立即咨询>"
        },
        {
          img: require("./images/组 2947.png"),
          title: "网红/主播/作家等自由职业",
          tell: "立即咨询>"
        },
        {
          img: require("./images/组 2948.png"),
          title: "建筑/工程/安装行业",
          tell: "立即咨询>"
        }
      ]
    };
  },
  components: {
    HeaderImg
  }
};
</script>

<style lang="scss" scoped>
.p-prepare {
  // width: 100%;
  padding: 50px 0;
  width: 1040px;
  margin: 0 auto;
  box-sizing: border-box;
  .prepare-h1 {
    padding-bottom: 20px;
  }
  .prepare-items {
    display: flex;
    .item-img {
      flex: 1;
      img {
        width: 90%;
      }
    }
    .item {
      flex: 1;
      // margin-left: 20px;
      display: flex;
      // align-items: center;
      justify-content: center;
      flex-direction: column;
      line-height: 26px;
      font-size: 16px;
    }
  }
}
// 解决方案
.quality {
  // width: 100%;
  width: 1040px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  // padding: 0 10%;
  box-sizing: border-box;
  padding-bottom: 50px;
  .quality-h1 {
    padding-top: 30px;
  }
  .quality-p1 {
    font-size: 16px;
    padding-top: 5px;
    padding-bottom: 30px;
    color: rgb(119, 118, 118);
  }
  .quality-items {
    width: 100%;
    display: flex;
    flex-flow: wrap;
    justify-content: space-between;
    .item {
      width: 32%;
      display: flex;
      flex-direction: column;
      margin-bottom: 15px;
      // justify-content: space-evenly;
      align-items: center;
      background-color: #fff;
      text-align: center;
      box-sizing: border-box;
      box-shadow: 1px 1px 4px #dddddd;
      .item-img {
        width: 100%;
        font-size: 11px;
        img {
          width: 100%;
        }
      }
    }
  }
}
// 多种
.multiple {
  width: 100%;
  min-width: 1040px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  padding: 30px 0;
  box-sizing: border-box;
  padding-bottom: 50px;
  background-color: #f7f7f7;
  .multiple-textn {
    width: 1040px;
    margin: 0 auto;
    p {
      margin-top: 8px;
    }
  }
  .multiple-items {
    width: 1040px;
    margin: 0 auto;
    display: flex;
    flex-flow: wrap;
    justify-content: space-between;
    align-content: space-between;
    margin-top: 40px;
    .item {
      width: 25%;
      position: relative;
      padding-bottom: 15px;
      padding-right: 15px;
      box-sizing: border-box;
      .item-img {
        position: relative;
        img {
          width: 100%;
        }
      }
      .item-text {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-left: 20px;
        line-height: 20px;
        p {
          font-weight: 700;
          color: #000;
          margin-bottom: 10px;
        }
        a {
          color: rgb(76, 118, 185);
        }
      }
    }
  }
}
// 经典案例回顾
.cancelled-case {
  width: 100%;
  width: 1040px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  // padding: 0 10%;
  box-sizing: border-box;
  padding-bottom: 50px;
  padding-top: 50px;
  .cancelled-case-h2 {
    padding-bottom: 20px;
    // font-size: 25px;
  }
  .case-frame {
    margin-bottom: 15px;
    .frame-item {
      width: 100%;
      padding: 30px;
      box-sizing: border-box;
      border: 1px solid #ccc;
      display: flex;
      .item-img {
        flex: 1;
        img {
          width: 100%
        }
      }
      .item-text {
        flex: 2;
        padding-left: 20px;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        // justify-content: center;
        h3 {
          margin-bottom: 5px;
          font-size: 15px;
        }
        p {
          line-height: 25px;
          font-size: 13px;
          color: rgb(100, 100, 100);
        }
      }
    }
  }

}
</style>


// WEBPACK FOOTER //
// src/components/planandprepare/planandprepare.vue